import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  Typography,
} from '@mui/material'
import { FC } from 'react'
import { TABLE_SECTION_MAX_NODE_COUNT } from 'src/features/templateEdit/section/table/model/tableSection'
import type { TableSectionSoftLimitViolation } from 'src/features/templateEdit/validates/validateTableSectionSoftLimit'

type Props = {
  open: boolean
  violations: TableSectionSoftLimitViolation[]
  onClose: () => void
}

/**
 * 表セクションのソフトリミット超過時に表示するエラーダイアログ。
 *
 * ひな形保存時の静的検証で 1 件以上の超過があった場合に表示し、保存を中断する（即死対策）。
 * 呼び出し側で `open` / `violations` を管理し、閉じる操作を `onClose` で受け取る。
 */
export const TableSectionSoftLimitErrorModal: FC<Props> = ({
  open,
  violations,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    aria-labelledby="table-section-soft-limit-error-title"
    aria-describedby="table-section-soft-limit-error-description"
  >
    <DialogTitle id="table-section-soft-limit-error-title">
      ひな形を保存できませんでした
    </DialogTitle>
    <DialogContent>
      <Typography
        id="table-section-soft-limit-error-description"
        variant="body1"
      >
        表の上限を超えているため保存できません。以下を修正してください。
      </Typography>
      <List sx={{ listStyleType: 'disc', pl: 3, mt: 1, py: 0 }}>
        {violations.map(({ sectionName, nodeCount }, index) => (
          <ListItem
            key={`${sectionName}-${index}`}
            sx={{ display: 'list-item', px: 0, py: 0.25 }}
          >
            {`表「${sectionName}」の項目数（質問・条件分岐の合計）が上限${TABLE_SECTION_MAX_NODE_COUNT}を超えています（現在${nodeCount}）。項目を減らしてください。`}
          </ListItem>
        ))}
      </List>
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" color="primary" onClick={onClose}>
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
)
